import { render } from "./SystemInventoryTypePage.vue?vue&type=template&id=2d0406f0"
import script from "./SystemInventoryTypePage.vue?vue&type=script&lang=js"
export * from "./SystemInventoryTypePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__